<template>
    <v-layout>
        <v-dialog v-model="deveMostarModalExlusao" persistent :max-width="Modal.Confirmacao.larguraMaxima">
            <v-card :min-width="Modal.Confirmacao.larguraMinima" :max-width="Modal.Confirmacao.larguraMaxima">
                <v-card-title class="primary modal-title my-0">
                    <span>Excluir reajuste</span>
                </v-card-title>
                <h4 class="mt-3 text-xs-center font-weight-black">
                    ⚠️ Atenção !!!
                </h4>
                <v-card-text class="text-xs-center grey--text text--darken-2">
                    <p> Esta ação afetará o cálculo automático de reajustes futuros do sistema.</p>
                    <p> Deseja realmente efetuar a exclusão do reajuste? </p>
                </v-card-text>
                <v-card-actions class="pa-3">
                    <v-btn color="botao-cancelar-color" outline flat @click="$emit('cancelar')"> Cancelar </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" depressed @click="$emit('confirmar')"> Excluir </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>

import {Modal} from '@/core/constants'

export default {
    name: 'ModalExcluirReajuste',
    props: ['deveMostarModalExlusao'],
    data() {
        return {
            Modal
        }
    }
}
</script>